import moment from 'moment';
import { CURRENT_PRODUCT_MODE, isAppModule } from '@src/utils/constants';
import {
  ECO_AI_ALERT_NWR_METRICS,
  DEFAULT_DIAGNOSTIC_DIMENSIONS_BY_PRODUCT,
  DEFAULT_FLOW_DIAGNOSTIC_DIMENSIONS,
  DEFAULT_FLOW_DIAGNOSTIC_METRICS_TYPES,
  ECO_DIAGNOSTICS_DIMENSIONS_BY_METRIC,
  AI_ALERT_KPI_DIAGNOSTICS_METRICS,
} from './constants';
import { getMetricMetaByKey } from '@src/utils/metrics';
import metricsStore from '@src/globalStore/metricsStore';
import { metricKeys } from '@pulse/metrics';

function generateDimensionListForMetric(metric, isFlowMetric) {
  return isFlowMetric
    ? DEFAULT_FLOW_DIAGNOSTIC_DIMENSIONS
    : ECO_DIAGNOSTICS_DIMENSIONS_BY_METRIC[metric] ??
        DEFAULT_DIAGNOSTIC_DIMENSIONS_BY_PRODUCT[CURRENT_PRODUCT_MODE];
}

export const createMetricConfigForMetrics = (
  metricList,
  isCustomMetricEnabled = false,
  isFlowEnabled = false,
) => {
  const metricConfig = metricList.map((metric) => {
    const metricInfo = getMetricMetaByKey({
      metricKey: metric,
    });
    const dimensionList = generateDimensionListForMetric(metric, !!metricInfo?.flowID);
    return {
      ...metricInfo,
      isCustom: isCustomMetricEnabled,
      isFlow: isFlowEnabled,
      dimensionList,
    };
  });
  return metricConfig;
};

export const getLocalTime = (date, tzOffset = null, timeFormat = 'HH:mm ll') => {
  return moment(date).format(timeFormat);
};

export const shouldShowImpactedUniques = (ecoAIAlert2, metric = '') =>
  !(isAppModule && ecoAIAlert2 && !ECO_AI_ALERT_NWR_METRICS.includes(metric));

export const getFlowAlertChartMetrics = (metricName) => {
  const flowConfigMetricMeta = getMetricMetaByKey({ metricKey: metricName, flowOverride: true });
  const flowId = flowConfigMetricMeta?.flowID;
  if (!flowId) return [];

  const { flowConfigMeta } = metricsStore.getState();
  const allFlowMetrics = flowConfigMeta?.[flowId]?.metrics || {};

  // Filter to only include the metric types we want for flow diagnostics
  // and return their metric IDs as an array
  const alertMetrics = Object.entries(allFlowMetrics)
    .filter(([metricType]) => DEFAULT_FLOW_DIAGNOSTIC_METRICS_TYPES.includes(metricType))
    .map(([, metricId]) => metricId);

  return [...alertMetrics, metricKeys.unique_devices];
};

/** Ordered chart/table metrics for an AI-alert diagnostics page. KPI alerts lead
 *  with the alerted count metric (so the selected card is an active metric)
 *  followed by base/companion metrics; all other alerts fall back to `fallbackList`. */
export const getAiAlertDiagnosticsMetricList = (
  alertMetricName: string,
  fallbackList: string[],
): string[] => {
  const kpiList = AI_ALERT_KPI_DIAGNOSTICS_METRICS[alertMetricName];
  return kpiList ? [...kpiList] : fallbackList;
};
